const setOnlineStationsList = data => ({
    type: "SET_ONLINE_STATIONS_LIST",
    data
  });

  export const mutation = {
    setOnlineStationsList
  };
  